import { Main } from "pages";
import { Navbar, Footer } from "components";
import { useUser } from "contexts/UserContext";

function App() {
  const { user } = useUser();
  return (
    <div className={user.isDark ? "dark" : ""}>
      <div className="w-90p m-auto">
        <Navbar />
        <Main />
        <Footer />
      </div>
    </div>
  );
}

export default App;
